/**
 * Streaming reply bubble (pure list transforms; de-slop CHAT-4 / CHAT-6).
 */
import type { ChatMessage } from '../../types';
import { STREAMING_BUBBLE_ID, WAITING_BUBBLE_ID } from './chatConstants';

export function hasRenderableStreamText(text: string): boolean {
  return text.replace(/​/g, '').trim().length > 0;
}

/**
 * Replace the "thinking" bubble with the streaming bubble carrying the text
 * accumulated so far. The bubble keeps one id and one timestamp for the whole
 * stream, so the thread row updates in place instead of remounting.
 */
export function applyStreamDelta(
  messages: ChatMessage[],
  accumulatedText: string,
  now: () => string = () => new Date().toISOString(),
): ChatMessage[] {
  const existing = messages.find((m) => m.id === STREAMING_BUBBLE_ID);
  const rest = messages.filter((m) => m.id !== WAITING_BUBBLE_ID && m.id !== STREAMING_BUBBLE_ID);
  return [
    ...rest,
    {
      id: STREAMING_BUBBLE_ID,
      role: 'assistant',
      content: accumulatedText,
      created_at: existing?.created_at ?? now(),
    },
  ];
}

export function removeStreamBubble(messages: ChatMessage[]): ChatMessage[] {
  return messages.filter((m) => m.id !== STREAMING_BUBBLE_ID);
}
